var _ellipse, _path, _rect, _rect2, _ellipse2, _path2, _rect3, _rect4, _ellipse3, _path3, _rect5, _rect6, _polygon, _path4, _path5, _path6, _path7, _polygon2, _polygon3, _path8, _path9, _path10, _circle, _polygon4, _path11, _polygon5, _polygon6, _circle2, _polygon7, _circle3, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "af8e4536-3e0b-4cf9-a0b4-bd60479f2728",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 949.72035,
    height: 767.83442,
    viewBox: "0 0 949.72035 767.83442",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 738.31694,
    cy: 538.00578,
    rx: 48.50275,
    ry: 98.96521,
    fill: "#3f3d56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M858.97775,766.07866c19.42586-116.55145.19557-232.6818-.00094-233.8403l-3.77868.64008c.19558,1.15288,19.31544,116.6731-.00094,232.57138Z",
    transform: "translate(-125.13983 -66.08279)",
    fill: "#e0e8fa"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 839.86385,
    y: 571.35817,
    width: 3.83318,
    height: 49.73959,
    transform: "translate(-206.13169 991.20198) rotate(-61.8584)",
    fill: "#e0e8fa"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 863.20238,
    y: 606.06946,
    width: 49.7413,
    height: 3.83318,
    transform: "translate(-306.94737 424.95757) rotate(-28.15796)",
    fill: "#e0e8fa"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 854.85467,
    cy: 381.37918,
    rx: 94.86568,
    ry: 193.56431,
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M969.42791,763.99514c37.944-227.6604.38273-454.4917-.00094-456.75629l-3.77868.64007c.38273,2.259,37.8336,228.48015-.00094,455.48737Z",
    transform: "translate(-125.13983 -66.08279)",
    fill: "#e0e8fa"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 935.68168,
    y: 383.44336,
    width: 3.83318,
    height: 97.28714,
    transform: "translate(-10.7695 988.96912) rotate(-61.8584)",
    fill: "#e0e8fa"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 979.49707,
    y: 453.16808,
    width: 97.28714,
    height: 3.83318,
    transform: "translate(-218.21638 472.94968) rotate(-28.15742)",
    fill: "#e0e8fa"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 630.17281,
    cy: 264.87747,
    rx: 129.81619,
    ry: 264.87747,
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M740.15609,763.99514c51.904-311.42024.524-621.7035-.00093-624.80093l-3.77869.64007c.524,3.09182,51.79358,312.765-.00093,623.532Z",
    transform: "translate(-125.13983 -66.08279)",
    fill: "#e0e8fa"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 695.37982,
    y: 243.35561,
    width: 3.83318,
    height: 133.12944,
    transform: "translate(-30.00782 712.52818) rotate(-61.8584)",
    fill: "#e0e8fa"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 754.63183,
    y: 339.47403,
    width: 133.12944,
    height: 3.83318,
    transform: "translate(-189.05666 361.82738) rotate(-28.15671)",
    fill: "#e0e8fa"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "910.513 700.231 0 700.231 0 698.05 910.908 698.05 910.513 700.231",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M281.13989,742H259.13977c-11.50788,0-21.78809.81433-28.57416,5.17487A36.9869,36.9869,0,0,0,198.13989,728H176.13977a36.99993,36.99993,0,0,0-36.99994,36.99994V765h179v-.00006C318.13983,744.56543,301.5744,742,281.13989,742Z",
    transform: "translate(-125.13983 -66.08279)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M881.1535,766.08279h93.97265c-.47461-17.53223-13.60546-21-35.98632-21h-22C894.759,745.08279,881.62811,748.55056,881.1535,766.08279Z",
    transform: "translate(-125.13983 -66.08279)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M318.357,505.91951h14a0,0,0,0,1,0,0v21a7,7,0,0,1-7,7h0a7,7,0,0,1-7-7v-21a0,0,0,0,1,0,0Z",
    transform: "translate(123.33 -154.65474) rotate(24.83609)",
    fill: "#ffb9b9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M324.21715,171.82885h.0001A50.99995,50.99995,0,0,1,375.2172,222.8288v57.00005a0,0,0,0,1,0,0h-102a0,0,0,0,1,0,0V222.8288a50.99995,50.99995,0,0,1,50.99995-50.99995Z",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "286.217 708.837 275.217 706.837 267.217 662.837 289.717 663.329 286.217 708.837",
    fill: "#ffb9b9"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "407.717 734.329 396.437 739.542 378.437 687.542 397.717 684.329 407.717 734.329",
    fill: "#ffb9b9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M527.857,753.41165l-29.5,1.50786-80.5-194.50786-2.19541,175.16761L387.357,731.91951c-19.95624-109.01056-36.468-205.84771-10.5-266.50786l88,7Z",
    transform: "translate(-125.13983 -66.08279)",
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M393.67344,805.57244l-11.44751-.61879a2.95914,2.95914,0,0,1-2.41814-4.4078l17.42365-30.91294,15.30047,1.275,2.36175,11.02149a11.17331,11.17331,0,0,1-4.03429,11.13641l-7.503,5.87854A9.64078,9.64078,0,0,1,393.67344,805.57244Z",
    transform: "translate(-125.13983 -66.08279)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M549.64469,830.30007l-9.88787,3.399a4.016,4.016,0,0,1-3.90262-.73465l-17.21007-14.59114a10.65761,10.65761,0,0,1-3.29419-11.26339l2.16141-7.02455,16.38531-3.17135,17.80971,27.39954A4.016,4.016,0,0,1,549.64469,830.30007Z",
    transform: "translate(-125.13983 -66.08279)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 317.2172,
    cy: 217.82885,
    r: 34,
    fill: "#ffb9b9"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "351.717 268.329 311.717 275.329 307.717 243.329 338.717 239.329 351.717 268.329",
    fill: "#ffb9b9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M476.857,483.41165l-103-10c5.05072-54.95356,21.97741-103.41947,57-142l50-4Z",
    transform: "translate(-125.13983 -66.08279)",
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "214.217 447.837 193.217 440.837 229.457 367.57 283.717 279.329 305.717 265.329 257.041 374.412 214.217 447.837",
    fill: "#3f3d56"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "340.217 206.829 278.217 218.829 288.217 187.829 324.217 179.829 352.217 189.829 340.217 206.829",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.08329,
    cy: 364.86298,
    r: 93.69065,
    fill: "#e0e8fa"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "320.426 471.91 263.743 457.087 207.059 442.263 248.238 400.586 289.418 358.908 304.922 415.409 320.426 471.91",
    fill: "#e0e8fa"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 212.19834,
    cy: 363.91447,
    r: 33.61481,
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M430.357,528.91951h14a0,0,0,0,1,0,0v21a7,7,0,0,1-7,7h0a7,7,0,0,1-7-7v-21a0,0,0,0,1,0,0Z",
    transform: "translate(143.34908 -199.5702) rotate(24.83609)",
    fill: "#ffb9b9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M450.357,539.91951l-18-11,9.43849-64.247L480.857,332.41165l7.4185,2.83648A31.91285,31.91285,0,0,1,507.792,372.979l-25.31459,98.77653Z",
    transform: "translate(-125.13983 -66.08279)",
    fill: "#3f3d56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyLocation);
export default __webpack_public_path__ + "static/media/whyLocation.da1dcce233cf1b5a6d72b375050470f0.svg";
export { ForwardRef as ReactComponent };